const input = document.querySelector(".myInput");
const questions = document.querySelectorAll(".question");
const questionsList = document.querySelector(".search-question__list");

function searchFunction() {
  let filter, title, text, i, txtValue;
  filter = input.value.toUpperCase();

  for (i = 0; i < questions.length; i++) {
    title = questions[i].getElementsByTagName("h3")[0];
    txtValue = title.textContent || title.innerText;
    if (txtValue.toUpperCase().includes(filter)) {
      questions[i].classList.add("_active");
      questionsList.classList.add("_active");
    } else {
      questions[i].classList.remove("_active");
    }
    if (filter == "") {
      questions[i].classList.remove("_active");
      questionsList.classList.remove("_active");
    }
  }
}

function clearInput() {
  if (input.value != "") {
    input.value = "";
    searchFunction();
  }
}

const questionPopupClose = document.querySelectorAll(".question__popup-close");
const questionPopup = document.querySelectorAll(".question__popup-wrapper");
const gotButton = document.querySelectorAll(".got-button");
for (let index = 0; index < questions.length; index++) {
  let question = questions[index];
  question.addEventListener("click", function (e) {
    questionPopup[index].classList.add("_active");
    document.body.parentNode.classList.add("body-lock");
  });
  questionPopupClose[index].addEventListener("click", function (e) {
    questionPopup[index].classList.remove("_active");
    document.body.parentNode.classList.remove("body-lock");
  });
  gotButton[index].addEventListener("click", function (e) {
    questionPopup[index].classList.remove("_active");
    document.body.parentNode.classList.remove("body-lock");
  });
}

let tabs = document.querySelectorAll("._tabs");
for (let index = 0; index < tabs.length; index++) {
  let tab = tabs[index];
  let tabs_items = tab.querySelectorAll("._tabs-item");
  let tabs_blocks = tab.querySelectorAll("._tabs-block");
  for (let index = 0; index < tabs_items.length; index++) {
    let tabs_item = tabs_items[index];
    tabs_item.addEventListener("click", function (e) {
      for (let index = 0; index < tabs_items.length; index++) {
        let tabs_item = tabs_items[index];
        tabs_item.classList.remove("_active");
        tabs_blocks[index].classList.remove("_active");
      }
      tabs_item.classList.add("_active");
      tabs_blocks[index].classList.add("_active");
      e.preventDefault();
    });
  }
}


// const faqOther = document.querySelectorAll(".faq-details-other");
const faqTracking = document.querySelectorAll(".faq-details-tracking");
const faqAccount = document.querySelectorAll(".faq-details-account");
const faqCheckout = document.querySelectorAll(".faq-details-checkout");
const faqReturn = document.querySelectorAll(".faq-details-return");
const faqPurchase = document.querySelectorAll(".faq-details-purchase");
const allFaq = document.querySelectorAll('.faq-details-all');

// const otherTab = document.querySelector(".other-tab");
const trackingTab = document.querySelector(".tracking-tab");
const accountTab = document.querySelector(".account-tab");
const checkoutTab = document.querySelector(".checkout-tab");
const returnTab = document.querySelector(".return-tab");
const purchaseTab = document.querySelector(".purchase-tab");
const allTabs = document.querySelector(".all-tabs");

// otherTab.innerHTML = faqOther.length;
trackingTab.innerHTML = faqTracking.length;
accountTab.innerHTML = faqAccount.length;
checkoutTab.innerHTML = faqCheckout.length;
faqReturn.innerHTML = returnTab.length;
purchaseTab.innerHTML = faqPurchase.length;
returnTab.innerHTML = faqPurchase.length;
allTabs.innerHTML = allFaq.length;
